import styled from 'styled-components';
import { Colors } from '../../config';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.BLACK};

  padding: 64px;

  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 48px 0;
    color: ${Colors.PRIMARY};
    text-align: center;
  }

  h2 {
    font-size: 1.125rem;
    font-weight: 600;
    margin: 24px 0 16px;
    color: ${Colors.PRIMARY};
  }

  p {
    font-size: 0.875rem;

    & + p {
      margin-top: 16px;
    }

    a {
      color: ${Colors.PRIMARY};
      text-decoration: none;
      transition: color 0.2s;
    }
  }

  ul {
    margin: 16px 0;
    li {
      font-size: 0.875rem;
      margin-left: 16px;
      & + li {
        margin-top: 16px;
      }
    }
  }

  strong {
    font-weight: 600;
    font-size: 0.875rem;
    margin-top: 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 75ch;
  margin: 0 auto;
`;
